import { createContext, useContext } from 'react';
import { AppBuilderContextType } from './index.functions';
export const AppBuilderContext = createContext<AppBuilderContextType | undefined>({} as AppBuilderContextType);

export function useAppBuilderContext() {
    const context = useContext(AppBuilderContext);
    if (!context) {
        throw new Error('useAppBuilderContext must be used within a AppBuilderContextProvider');
    }
    return context;
}
